module.exports = __webpack_public_path__ + "static/media/ss15_preview.447583b5.jpg";